<!--
 * @Author: fang.diao
 * @Date: 2024-12-11 17:20:20
 * @LastEditors: Hankill(hao.chen)
 * @LastEditTime: 2024-12-25 15:46:31
 * @FilePath: /web_artemisads/src/pages/seller/product/fileBar/index.vue
 * @Description: 
-->
<template>
  <div class="file-bar" ref="fileBarRef">
    <div class="content-wrap">
      <div class="content">
       
        <div class="right">
          <a-dropdown :getPopupContainer="() => fileBarRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleMenuClick">
                <a-menu-item key="all">
                  <div class="actions-item">
                    <span>{{ $t('seller.productTable.exportMenuAll') }}</span>
                    <span v-if="exportsNum.allProductCount" class="num">{{exportsNum.allProductCount}}</span>
                  </div>
                </a-menu-item>
                <a-menu-item key="active">
                  <div class="actions-item">
                    <span>{{ $t('seller.productTable.exportMenuActive') }}</span>
                    <span v-if="exportsNum.activeProductCount" class="num">{{exportsNum.activeProductCount}}</span>
                  </div>
                </a-menu-item>
                <a-menu-item key="inactive">
                  <div class="actions-item">
                    <span>{{ $t('seller.productTable.exportMenuInactive') }}</span>
                    <span v-if="exportsNum.inActiveProductCount" class="num">{{exportsNum.inActiveProductCount}}</span>
                  </div>
                </a-menu-item>
                <a-menu-item key="filter">
                  <div class="actions-item">
                    <span>{{ $t('seller.productTable.exportMenuFiltered') }}</span>
                    <span v-if="exportsNum.filterProductCount" class="num">{{exportsNum.filterProductCount}}</span>
                  </div>
                </a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special>
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">{{ $t('seller.productTable.exportButtonLabel') }}</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
          <a-dropdown :getPopupContainer="() => fileBarRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleMenuClickUpdate">
                <a-menu-item key="bulkUpdate">
                  <svg class="icon shangchuan2" aria-hidden="true">
                    <use xlink:href="#icon-shangchuan2"></use>
                  </svg>
                  <span class="btn-text">{{ $t('seller.productTable.updateProductsMenu') }}</span>
                </a-menu-item>
                <a-menu-item key="manageDeals">
                  <svg class="icon shangchuan2" aria-hidden="true">
                    <use xlink:href="#icon-shangchuan2"></use>
                  </svg>
                  <span class="btn-text">{{ $t('seller.productTable.manageDealsMenu') }}</span>
                </a-menu-item>
               
              </artmisads-dropdown-menu>
            </template>
             <artmisads-button-special>
              <svg class="icon shangchuan2" aria-hidden="true">
                <use xlink:href="#icon-shangchuan2"></use>
              </svg>
              <span class="btn-text">{{ $t('seller.productTable.bulkUpdateManageButton') }}</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
          <!-- <artmisads-button-special @click="() => setShowUpdateProductModal(true)">
            <svg class="icon shangchuan2" aria-hidden="true">
              <use xlink:href="#icon-shangchuan2"></use>
            </svg>
            <span class="btn-text">{{activeTab === '0' ? 'Bulk Update Attribution Products' : 'Bulk Update Associate Products'}}</span>
          </artmisads-button-special> -->
        </div>
      </div>
    </div>
    <div class="activate-brand" ref="activateBrand">
      <artmisads-modal
        v-model:open="showUpdateProductModal"
        :title="activeTab === '0' ? $t('seller.productTable.modalBulkUpdateAttributionCsv') : $t('seller.productTable.modalBulkUpdateAssociateCsv')"
        :width="1200"
        :getContainer="() => fileBarRef"
        :destroyOnClose="true"
        :maskClosable="false"
        :footer="null"
        :onCancel="onCancel"
      >
        <div>
          <exampleTable
            v-if="showExample"
            :setDataList="setDataList"
            :dataList="dataList"
            :setShowExample="setShowExample"
            :activeTab="props.activeTab"
          />
          <failSuccessList
            v-else
            :dataList="dataList"
            :showExample="showExample"
            :setDataList="setDataList"
            :setShowUpdateProductModal="setShowUpdateProductModal"
            :getProductList="getProductList"
            :setShowExample="setShowExample"
            :onCancel="onCancel"
            :activeTab="props.activeTab"
          />
        </div>
      </artmisads-modal>
      <artmisads-modal
        v-model:open="showUpdateProductDealsModal"
        :title="$t('seller.productTable.modalUpdateProductDeals')"
        :width="1200"
        :getContainer="() => fileBarRef"
        :destroyOnClose="true"
        :maskClosable="false"
        :footer="null"
        :onCancel="onDealsCancel"
      >
        <div>
          <uploadProductDeals
            v-if="showDealsResultModal"
            :setDataList="setDataList"
            :dataList="dataList"
            :activeTab="props.activeTab"
            :setShowExample="setShowDealsResultModal"
          />
          <productDealsResult
            v-else
            :dataList="dataList"
            :showExample="showDealsResultModal"
            :setDataList="setDataList"
            :setShowUpdateProductModal="setShowUpdateProductDealsModal"
            :getProductList="getProductList"
            :activeTab="props.activeTab"
            :setShowExample="setShowDealsResultModal"
            :onCancel="onDealsCancel"
          />
        </div>
      </artmisads-modal>
    </div>
  </div>
</template>
<script setup>
  import { onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import exampleTable from './exampleTable.vue';
  import failSuccessList from './failSuccessList.vue';
  import uploadProductDeals from './uploadProductDeals.vue';
  import productDealsResult from './productDealsResult.vue';
  import { productsApi } from '../../../../../server/index'
  import { Modal } from 'ant-design-vue';

  const { t } = useI18n();
  const showUpdateProductModal = ref(false);
  const showExample = ref(true);

  const showUpdateProductDealsModal = ref(false);
  const showDealsResultModal = ref(true);

  const dataList = ref({
    failList: [],
    successList: []
  });
  const fileBarRef = ref(null);
  const props = defineProps([ 'params', 'getProductList', 'exportsNum','activeTab']);

  const setShowUpdateProductModal = status => {
    showUpdateProductModal.value = status;
  }

  const setShowExample = status => {
    showExample.value = status;
  }
  
  const setShowUpdateProductDealsModal = status => {
    showUpdateProductDealsModal.value = status;
  }

  const setShowDealsResultModal = status => {
    showDealsResultModal.value = status;
  }

  const onDealsCancel = () => {
    showUpdateProductDealsModal.value = false;
    dataList.value = {
      failList: [],
      successList: []
    };
    showDealsResultModal.value = true;
  }

  const setDataList = data => {
    dataList.value = data;
  }

  const onCancel = (isUpdate) => {
    if(isUpdate){
    showUpdateProductModal.value = false;
      return;
    }
   if(!dataList.value.failList.length && !dataList.value.successList.length){
    showUpdateProductModal.value = false
    return
   }
    showUpdateProductModal.value = true;
    Modal.confirm({
      title: t('seller.common.confirm'),
      content: t('seller.productTable.closeCsvUploadConfirm'),
      okText: t('seller.common.confirm'),
      okType: 'danger',
      onOk: () => {
        showUpdateProductModal.value = false;
        dataList.value = {
          failList: [],
          successList: []
        };
        showExample.value = true;
    showUpdateProductModal.value = false;
      },
      cancelText: t('seller.common.cancel'),
      onCancel: () => {
        // Do nothing
      }
    })
  }
  const handleMenuClickUpdate=async({key})=>{
    if(key === 'bulkUpdate'){
      setShowUpdateProductModal(true);
    }
    if(key === 'manageDeals'){
      setShowUpdateProductDealsModal(true);
    }
  }
  const handleMenuClick = async ({ key }) => {
    let exportParams = { exportType: key }, newExportParams = {};
    if (key === 'filter') {
      exportParams = {...props.params, ...exportParams };
    }
    for(let item in exportParams) {
      if (exportParams[item]) {
        newExportParams[item] = exportParams[item];
      }
    }
    
    const finalParams = {
      qs: newExportParams,
      fileName: t('seller.productTable.exportCsvFileName')
    }
    if(props.activeTab === '0') {
    productsApi.exportProduct(finalParams);
    
    }else{
      productsApi.exportAssociateProduct(finalParams);
    }
  }

  const checkFromDashboard = () => {
    const artemisAds_dashboard_click_product_deal = localStorage.getItem('artemisAds_dashboard_click_product_deal');
    if (artemisAds_dashboard_click_product_deal === '1') {
      setShowUpdateProductModal(true);
      localStorage.setItem('artemisAds_dashboard_click_product_deal', '');
    }
  }

  onMounted(() => {
    checkFromDashboard();
  })


</script>
<style lang="less" scoped>
  .shangchuan2 {
          width: 20px;
          height: 20px;
          fill: var(--dark-1);
          margin-right: 8px;
        }
  .file-bar {
    display: flex;
    justify-content: right;
    padding: 14px 16px 0 16px;
    background-color: var(--color-white);
    .content-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-bottom: 17px;
      // border-bottom: 1px solid var(--border-4);
      > h2 {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
      }
    }
    .content {
      width: 100%;
      display: flex;
      button {
        cursor: pointer;
        display: flex;
        
        .jiantou {
          width: 16px;
          height: 16px;
          fill: var(--dark-3);
          margin-left: 8px;
        }
        .daochu {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: var(--dark-1);
        }
        > svg {
          align-self: center;
        }
        > span {
          align-self: center;
        }
        .btn-text {
          align-self: center;
          font-weight: 500;
          line-height: 20px;
          margin-right: 8px;
        }
      }
      .right {
        flex: 1;
        display: flex;
        justify-content: right;
        > button {
          margin-left: 16px;
        }
      }
    }
    
  }
</style>
